import { NavLink, Outlet } from "react-router-dom";
import {
  ArrowLeft,
  Users,
  UserCheck,
  UserPlus,
  ClipboardList,
  FormInput,
  Bell,
  Key,
  Tag,
  FileCode,
  Layers,
} from "lucide-react";
import { cn } from "@/lib/utils";

const settingsNavigation = [
  { name: "Users", href: "/settings/users", icon: Users },
  { name: "User Roles", href: "/settings/user-roles", icon: Tag },
  { name: "Approval Roles", href: "/settings/approval-roles", icon: UserCheck },
  {
    name: "Default Approvers",
    href: "/settings/default-approvers",
    icon: UserPlus,
  },
  {
    name: "Approval Templates",
    href: "/settings/approval-templates",
    icon: ClipboardList,
  },
  { name: "Request Fields", href: "/settings/request-fields", icon: FormInput },
  { name: "Alert Configs", href: "/settings/alert-configs", icon: Bell },
  { name: "API Keys", href: "/settings/api-keys", icon: Key },
  {
    name: "Release Notes Templates",
    href: "/settings/service-templates",
    icon: FileCode,
  },
  {
    name: "Section Types",
    href: "/settings/section-types",
    icon: Layers,
  },
];

export default function SettingsLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Settings Sidebar */}
      <aside className="fixed inset-y-0 left-0 w-64 bg-gray-900">
        {/* Back to Dashboard */}
        <div className="h-16 flex items-center px-4 border-b border-gray-800">
          <NavLink
            to="/"
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
            <span className="text-sm font-medium">Back to Dashboard</span>
          </NavLink>
        </div>

        {/* Settings Header */}
        <div className="px-4 py-4">
          <h2 className="text-lg font-semibold text-white">Org Settings</h2>
          <p className="text-xs text-gray-400 mt-1">
            Manage organization configuration
          </p>
        </div>

        {/* Navigation */}
        <nav className="px-3">
          <ul className="space-y-1">
            {settingsNavigation.map((item) => (
              <li key={item.name}>
                <NavLink
                  to={item.href}
                  className={({ isActive }) =>
                    cn(
                      "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                      isActive
                        ? "bg-gray-800 text-white"
                        : "text-gray-400 hover:bg-gray-800 hover:text-white",
                    )
                  }
                >
                  <item.icon className="h-5 w-5" />
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>

      {/* Main content */}
      <main className="pl-64">
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
